<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" class="cadastre-building" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Парент <span class="red">*</span></label>
                        <v-select v-model="data.parent" label="name"
                                  :options="parents"
                                  :filterable="false"
                                  @search="onParentSearch"
                                  @search:focus="onParentFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>Код <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{ $t("realEstate.validation.cadastreBuildingFieldReferenceEdit.code") }}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingFieldReferenceEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст(ru) <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingFieldReferenceEdit.nameRu")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Сортировка</label>
                        <numeric-input v-model="data.sortOrder" :precision="0"></numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Кадастр коди</label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.cadastreCode"
                        />
                    </div>
                    <div class="form-check">
                        <label class="form-check-label pl-0">
                            <input class="form-check-input" type="checkbox" v-model="data.active">
                            <span class="form-check-sign"></span>
                            Актив
                        </label>
                    </div>
                </div>
                <div v-if="data.parent && data.parent.id" class="col-12">
                    <template v-if="data.parent.data && data.parent.data.childFields && data.parent.data.childFields.length > 0">
                        <div class="form-group" v-for="field in data.parent.data.childFields" :key="field.code">
                            <label>{{field.name}} <span class="red">*</span></label>
                            <template v-if="field.type">
                                <template v-if="field.type === 'TEXT'">
                                    <input type="text" class="form-control" v-model="field.value" />
                                </template>
                                <template v-else-if="field.type === 'INTEGER'">
                                    <numeric-input v-model="field.value" />
                                </template>
                                <template v-else-if="field.type === 'DECIMAL'">
                                    <numeric-input v-model="field.value" :precision="2" />
                                </template>
                                <template v-else-if="field.type === 'LISTBOX'">
                                    <select class="form-control" v-model="field.value">
                                        <option :value="option.code" v-for="option in field.options" :key="option.code">{{option.name}}</option>
                                    </select>
                                </template>
                                <template v-else-if="field.type === 'MULTISELECT'">
                                    <select class="form-control" v-model="field.value" multiple>
                                        <option :value="option.code" v-for="option in field.options" :key="option.code">{{option.name}}</option>
                                    </select>
                                </template>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="col-12" v-else>
                    <div class="form-group">
                        <label>Қўшимча параметерлар (Ички референслар учун)</label>
                        <div class="table-responsive">
                          <div class="table-wrapper">
                            <table class="table table-striped" style="min-width: 500px;">
                                <thead>
                                <tr>
                                    <th width="15%">Код</th>
                                    <th width="25%">Текст</th>
                                    <th width="15%">Тип</th>
                                    <th width="100%">Опциялар</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="childFields && childFields.length > 0">
                                    <tr v-for="field in childFields" :key="field.id">
                                        <td style="vertical-align: top">
                                            <input type="text" class="form-control" v-model="field.code"/>
                                        </td>
                                        <td style="vertical-align: top">
                                            <input type="text" class="form-control" v-model="field.name"/>
                                        </td>
                                        <td style="vertical-align: top" width="25%">
                                            <select class="form-control" v-model="field.type">
                                                <option value="TEXT">TEXT</option>
                                                <option value="INTEGER">INTEGER</option>
                                                <option value="DECIMAL">DECIMAL</option>
                                                <option value="LISTBOX">LISTBOX</option>
                                                <option value="MULTISELECT">MULTISELECT</option>
                                            </select>
                                        </td>
                                        <td class="align-top">
                                            <template v-if="field.type && (field.type === 'LISTBOX' || field.type === 'MULTISELECT')">
                                                <div class="row mb-1" v-for="option in field.options" :key="option.id">
                                                    <div class="col-6">
                                                        <input type="text" class="form-control" v-model="option.code" placeholder="Kod"/>
                                                    </div>
                                                    <div class="col-6">
                                                        <input type="text" class="form-control" v-model="option.name" placeholder="Nomi"/>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12 text-right">
                                                        <button class="all-btn add-btn icon-btn" @click="addFieldOption(field)">+</button>
                                                    </div>
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                                <tr>
                                    <td>
                                        <button class="all-btn add-btn" @click="addField">Параметер қўшиш</button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_BUILDING_REFERENCE_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: "ReferenceEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                parentFilter: initFilterModel(),
                data: this.initEmptyData(),
                lastFieldId: 0,
                childFields: [],
                values: {},
                parents: []
            }
        },
        validations:{
            data:{
                code:{
                    required
                },
                name:{
                    required
                },
                nameRu: {
                    required
                }
            }
        },
        methods: {
            initEmptyData() {
                return {
                    code: '',
                    name: '',
                    nameRu: '',
                    book: null,
                    parent: null,
                    cadastreCode: '',
                    sortOrder: null
                }
            },
            addField() {
                this.lastFieldId += 1;
                this.childFields.push({
                    id: this.lastFieldId,
                    code: '',
                    name: '',
                    type: '',
                    options: []
                });
            },
            addFieldOption(field) {
                if (!field.lastIndex) {
                    field.lastIndex = 0;
                }
                if (!field.options) {
                    field.options = [];
                }
                field.lastIndex += 1;
                field.options.push({
                    id: field.lastIndex,
                    code: '',
                    name: ''
                });
            },
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.data.data = {};
                if (this.data.parent && this.data.parent.id && this.data.parent.id > 0) {
                    this.data.data.values = {};
                    if (this.data.parent.data && this.data.parent.data.childFields && this.data.parent.data.childFields.length > 0) {
                        this.data.parent.data.childFields.forEach((field) => {
                            if (field.code && field.value) {
                                this.data.data.values[field.code] = field.value;
                            }
                        });
                    }
                } else {
                    if (this.childFields && this.childFields.length > 0) {
                        this.data.data.childFields = this.childFields.filter((field) => {
                            return field.code && field.code.length > 0 && field.name && field.name.length > 0;
                        });
                        this.lastFieldId = 0;
                        this.data.data.childFields.forEach((field) => {
                            this.lastFieldId += 1;
                            field.id = this.lastFieldId;
                            if (field.options && field.options.length > 0) {
                                if (field.type === 'LISTBOX' || field.type === 'MULTISELECT') {
                                    field.options = field.options.filter((option) => {
                                        return option.code && option.code.length > 0 && option.name && option.name.length > 0;
                                    });
                                } else {
                                    field.options = null;
                                }
                            }
                        });
                    }
                }
                this.$http.post('cadastre/building/field/reference', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('cadastreBuildingFieldReferenceChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            onParentSearch(searchTxt, loading) {
                loading(true);
                this.parents = [];
                this.parentFilter.search = searchTxt;
                this.$http.post('cadastre/building/field/reference/list', this.parentFilter)
                    .then(res => {
                        this.parents = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onParentFocus() {
                this.parents = [];
                this.parentFilter.search = '';
                this.$http.post('cadastre/building/field/reference/list', this.parentFilter)
                    .then(res => {
                        this.parents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.parentFilter.parentOnly = true;
            this.parentFilter.page.size = 1000;
            this.$eventBus.$on('showCadastreBuildingFieldReferenceEditModal', (data) => {
                this.childFields = [];
                this.values = {};
                this.lastFieldId = 0;
                if (data) {
                    if (data.parent && data.parent.data && data.parent.data.childFields && data.parent.data.childFields.length > 0) {
                        data.parent.data.childFields.forEach((field) => {
                            if (data.data && data.data.values && data.data.values.hasOwnProperty(field.code)) {
                                field.value = data.data.values[field.code];
                            } else {
                                if (field.type === 'LISTBOX' || field.type === 'MULTISELECT') {
                                    field.value = [];
                                } else {
                                    field.value = null;
                                }
                            }
                        });
                    }
                    if (data && data.data && data.data.childFields && data.data.childFields.length > 0) {
                        this.lastFieldId = 0;
                        data.data.childFields.forEach((field) => {
                            this.lastFieldId += 1;
                            field.id = this.lastFieldId;
                            if (!field.options) {
                                field.options = [];
                            }
                            this.childFields.push(field);
                        });
                    }
                    this.data = clone(data);
                } else {
                    this.data = this.initEmptyData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>
